var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#E1E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8667 14C17.7459 13.7905 17.5704 13.6178 17.3591 13.5004C17.1477 13.3829 16.9083 13.3252 16.6667 13.3333H15.3333C14.9797 13.3333 14.6406 13.4738 14.3905 13.7239C14.1405 13.9739 14 14.313 14 14.6667C14 15.0203 14.1405 15.3594 14.3905 15.6095C14.6406 15.8595 14.9797 16 15.3333 16H16.6667C17.0203 16 17.3594 16.1405 17.6095 16.3905C17.8595 16.6406 18 16.9797 18 17.3333C18 17.687 17.8595 18.0261 17.6095 18.2761C17.3594 18.5262 17.0203 18.6667 16.6667 18.6667H15.3333C15.0917 18.6748 14.8523 18.6171 14.6409 18.4996C14.4296 18.3822 14.2541 18.2095 14.1333 18M16 12.6667V19.3333M10 16C10 16.7879 10.1552 17.5681 10.4567 18.2961C10.7583 19.0241 11.2002 19.6855 11.7574 20.2426C12.3145 20.7998 12.9759 21.2417 13.7039 21.5433C14.4319 21.8448 15.2121 22 16 22C16.7879 22 17.5681 21.8448 18.2961 21.5433C19.0241 21.2417 19.6855 20.7998 20.2426 20.2426C20.7998 19.6855 21.2417 19.0241 21.5433 18.2961C21.8448 17.5681 22 16.7879 22 16C22 15.2121 21.8448 14.4319 21.5433 13.7039C21.2417 12.9759 20.7998 12.3145 20.2426 11.7574C19.6855 11.2002 19.0241 10.7583 18.2961 10.4567C17.5681 10.1552 16.7879 10 16 10C15.2121 10 14.4319 10.1552 13.7039 10.4567C12.9759 10.7583 12.3145 11.2002 11.7574 11.7574C11.2002 12.3145 10.7583 12.9759 10.4567 13.7039C10.1552 14.4319 10 15.2121 10 16Z",
    stroke: "#5856D6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.9c4f00ca425e700a438601d74430ac22.svg";
export { ForwardRef as ReactComponent };